
<select id="field-2" name="field-2" data-name="Field 2" required="" class="w-select" [(ngModel)]="chosenEvaluation" (change)="onSelect()">
    <option disabled selected>{{ 'selectEval' | translate }}</option>
    <option *ngFor="let evaluation of evaluations" [ngValue]="evaluation" >{{evaluation.name}}</option>
</select>
<div *ngIf="!this.chosenEvaluation" style="display: flex;" class="error-message w-form-fail">
    <div class="error-text">{{ 'selectEvalErrorMessage' | translate }}</div>
</div>